module.exports = __webpack_public_path__ + "img/Tan.6a9be0ab.png";